import React from "react";
import { CarouselLayoutOptions, useLayouts } from "@jelly/lesson";
import { UIOverride } from "@src/lms/jelly/extensions/layouts/ui-overrde/UIOverride";
import { CarouselButton } from "@src/lms/jelly/extensions/ui";

import styles from "./Carousel.module.scss";

export const Carousel: React.FC<CarouselLayoutOptions & { children: never }> = (props) => {
  const { carousel: CoreCarousel } = useLayouts();

  return (
    <UIOverride
      overrides={{
        ui: {
          Button: CarouselButton,
        },
      }}
    >
      {/*// @ts-expect-error - layout props are incorrectly exposed - 'style' prop is missing */}
      <CoreCarousel {...props} style={styles} />
    </UIOverride>
  );
};
